import { connect } from 'react-redux';

import { getUserMode } from 'datamodel/User/utils';
import BookingSettings from './booking-settings';

export default connect((state) => ({
  userMode: getUserMode(state.User.mode),
}))(BookingSettings);
